import { MiniGame } from './types';
import PieceWhack from './PieceWhack';
import SpotTheOddOne from './SpotTheOddOne';
import TicTacToe from './TicTacToe';
import SlidePuzzle from './SlidePuzzle';

// The quiver of mini-games. Add one here and it's automatically in the rotation — the evaluation
// loader picks one at random each time it opens, and the Mini games menu overlay lists them all.
export const MINI_GAMES: MiniGame[] = [
  { id: 'piece-whack', name: 'Whack the piece', tabLabel: 'Whack', Component: PieceWhack },
  { id: 'spot-odd', name: 'Spot the odd piece out', tabLabel: 'Spot', Component: SpotTheOddOne },
  { id: 'tic-tac-toe', name: 'Tic-Tac-Toe', Component: TicTacToe },
  { id: 'slide-puzzle', name: 'Slide puzzle', tabLabel: 'Slide', Component: SlidePuzzle },
];

export function pickRandomMiniGame(): MiniGame {
  return MINI_GAMES[Math.floor(Math.random() * MINI_GAMES.length)];
}

export type { MiniGame } from './types';
